<script>
  import Multiselect from 'vue-multiselect'

  export default {
    components: {
      Multiselect,
    },
    model: {
      prop: 'value',
      event: 'change',
    },
    props: {
      value: {
        type: null,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      getData: {
        type: null,
        default: null,
      },
      label: {
        type: String,
        default: 'name',
      },
      trackBy: {
        type: String,
        default: 'id',
      },
      customLabel: {
        type: Function,
        default (option, label) {
          if (!option) return ''
          return label ? option[label] : option
        },
      },
    },
    data() {
      return {
        model: this.value,
        options: [],
        isLoading: false,
        isInitial: false,
      }
    },
    watch: {
      model (val) {
        this.$emit('change', val)
      },
      value (val) {
        if (!this.isInitial) {
          this.model = this.value
          this.isInitial = true
        }
      },
    },
    async created() {
      await this.search()
      this.model = this.value
    },
    methods: {
      async search (query) {
        if (typeof this.getData !== 'function') {
          return
        }
        this.isLoading = true
        const { data } = await this.getData({
          search: query
        })
        this.options = data.data
        this.isLoading = false
        if (!this.isInitial && this.value) {
          this.model = this.value
          this.isInitial = true
        }
      },
      tryToAddTag (tag) {
        const newOption = {
          [this.label]: tag
        }
        if (!this.model) {
          this.model = []
        }
        this.options.push(newOption)
        this.model.push(newOption)
      },
    }
  }
</script>

<template>
  <Multiselect
    v-model="model"
    v-bind="$attrs"
    :multiple="true"
    :class="{
      'scrollable': options.length > 7,
    }"
    :options="options"
    :taggable="true"
    :label="label"
    :track-by="trackBy"
    :custom-label="customLabel"
    :loading="isLoading"
    :internal-search="false"
    :disabled="disabled"
    @search-change="search"
    @tag="tryToAddTag"
  />
</template>
